// @ts-nocheck

import type {
  PresignedUrlRequest,
  PresignedUrlResponse,
} from '../../@types/contracts';
import { makeAPIRequestV2 } from '../../utils/api';
import AnnotatorConstants from '../annotator/annotator.constants';

export const ERROR = 'ERROR';
export const READY_TO_UPLOAD = 'READY_TO_UPLOAD';
export const UPLOADING = 'UPLOADING';
export const UPLOADED = 'UPLOADED';
export const ANALYZING = 'ANALYZING';
export const COMPLETED = 'COMPLETED';

export const UPDATE_ANALYSIS_MAP = 'UPDATE_ANALYSIS_MAP';
export const UPDATE_ANALYSIS_STATUS = 'UPDATE_ANALYSIS_STATUS';
export const UPDATE_OVERALL_ANALYSIS_STATUS = 'UPDATE_OVERALL_ANALYSIS_STATUS';

// These use cases are defined in the Nucleus API Contract
export enum PresignedUrlUseCase {
  DEFAULT_IMAGE_UPLOAD = 'DEFAULT_IMAGE_UPLOAD',
  PPD_IMAGE_UPLOAD = 'PPD_IMAGE_UPLOAD',
}

export function addImageToState(data = {}, user = {}) {
  return {
    type: AnnotatorConstants.FETCH_AI_RESULTS_SUCCESS,
    response: { data, user },
  };
}

export async function generatePresignedURL(
  fileName: string,
  patientId: string,
  useCase?: PresignedUrlUseCase,
) {
  const data: PresignedUrlRequest = {
    fileName,
    patientId,
    useCase: useCase || PresignedUrlUseCase.DEFAULT_IMAGE_UPLOAD,
  };

  try {
    const { data: presignedURL }: PresignedUrlResponse = await makeAPIRequestV2(
      '/images/get-upload-url',
      { data },
      'POST',
    );
    return presignedURL;
  } catch (e) {
    return null;
  }
}
